import { useTheme } from "@mui/material";
import { CarPortfolioChartItem } from "@app/pages/assetAllocation/asset-allocation-types";
import {
  CarPdfHeader,
  CarPdfHeaderCell,
  CarPdfRow,
  CarPdfTable,
  CarPdfTableProps,
  CarPdfTextCell,
} from "@app/components/PdfTable";
import { getMultiPeriodReturnComparisonExcelTable } from "@app/pages/assetAllocation/editPortfolioGroup/TableMultiPeriodReturnComparison";
import {
  ExcelDataFormat,
  excelTableFormatValue,
} from "@app/hooks/useExcelExport";
import {
  CarPortfolioAssetTableData,
  CarPortfolioStatRow,
} from "@app/pages/assetAllocation/usePortfolioGroupVersionData";
import { formatDisplayTypeValue, formatPercentFactor } from "@app/utils";

interface HistoricalMarketSummaryPdfTableProps
  extends Omit<CarPdfTableProps, "children" | "collWidths"> {
  tableData: CarPortfolioAssetTableData;
  moduleId: string;
  rows: CarPortfolioStatRow[];
}

export const HistoricalMarketSummaryPdfTable = ({
  tableData,
  rows,
  moduleId,
  ...props
}: HistoricalMarketSummaryPdfTableProps) => {
  const theme = useTheme();

  const hasTimeFrameRow = rows.some((i) => i.code === "EXPECTED_RETURN");

  const band = tableData.bands.find((b) => b.moduleId === moduleId);

  if (!band) {
    return <></>;
  }

  return (
    <CarPdfTable
      colWidths={[1.5, ...band.columns.map(() => 1)]}
      isRounded
      isStriped
      {...props}
    >
      <CarPdfHeader paddingVertical={14}>
        <CarPdfHeaderCell key="label"></CarPdfHeaderCell>
        {band.columns.map((i, idx) => (
          <CarPdfHeaderCell key={idx}>{i.label}</CarPdfHeaderCell>
        ))}
      </CarPdfHeader>
      {rows.map((row, rowIdx) => {
        const module = row.modules.find((m) => m.moduleId === moduleId);

        return (
          <CarPdfRow key={rowIdx} paddingVertical={10}>
            <CarPdfTextCell
              key="label"
              style={{
                paddingHorizontal: 15,
                textAlign: "left",
              }}
            >
              {row.name}
            </CarPdfTextCell>
            {module?.values.map((value, valueIdx) => (
              <CarPdfTextCell
                key={valueIdx}
                style={{
                  paddingHorizontal: 15,
                }}
              >
                {formatDisplayTypeValue(row.displayType)(value.allocation)}
              </CarPdfTextCell>
            ))}
          </CarPdfRow>
        );
      })}
    </CarPdfTable>
  );
};
